import { Fragment, useMemo } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { useParams } from "react-router";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { type ITemplate, ModuleType, TokenType } from "@framework/types";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { TemplateListItem, TemplateSearchForm } from "../../../../components";

export interface IErc1155TokenListProps {
  embedded?: boolean;
}

export const Erc1155TemplateList = (props: IErc1155TokenListProps) => {
  const { embedded } = props;

  const { id } = useParams<{ id: string }>();

  const initialSearchValues = useMemo(() => {
    return {
      contractIds: embedded ? [~~id!] : [],
    };
  }, [id]);

  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<ITemplate>
  >("/erc1155/templates", { enableInfiniteScroll: isMd, embedded }, void 0, initialSearchValues);

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc1155", "erc1155.templates"]} isHidden={embedded} />

      <PageHeader message="pages.erc1155.templates.title" />

      <TemplateSearchForm
        initialValues={initialSearchValues}
        contractType={[TokenType.ERC1155]}
        contractModule={[ModuleType.HIERARCHY]}
        embedded={embedded}
      />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(token => (
              <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={token.id}>
                <TemplateListItem template={token} path="/erc1155/templates" />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
